import { z } from 'zod';
import { companyTypeSchema } from './company-type.schema';
import { eldPartnerTypeSchema } from './eld-partner-type.schema';
import { partnerIntegrationCredentialsSchema } from './partner-integration-credentials.schema';
import { partnerPurchaseOrderConfigurationSchema } from './partner-purchase-order-configuration.schema';

export const accountSummarySchema = z.object({
  companyName: z.string().nullable(),
  companyCode: z.string().nullable(),
  companyType: companyTypeSchema,
  externalAccountId: z.string().nullable(),
  partnerName: z.string().nullable(),
  partnerId: z.string().nullable(),
  partnerEmail: z.string().nullable(),
  partnerPhone: z.string().nullable(),
  partnerPurchaseOrderConfiguration: partnerPurchaseOrderConfigurationSchema,
  eldPartnerType: eldPartnerTypeSchema.nullable(),
  partnerIntegrationCredentials: z.array(partnerIntegrationCredentialsSchema),
});

export type AccountSummary = z.infer<typeof accountSummarySchema>;
